import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function VendorsList() {
  const [vendors, setVendors] = useState([]);
  useEffect(() => { client.get("/vendors").then(r => setVendors(r.data)); }, []);
  return (
    <div className="container-editorial mt-8 md:mt-14">
      <div className="border-b border-[#EAE5D9] pb-10 mb-12">
        <p className="label-uppercase text-[#B24C38]">The Ateliers</p>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tighter mt-3">Our Vendors</h1>
        <p className="text-[#4A4A4A] mt-4 max-w-xl">
          Every vendor on Kesher is Jewish-owned. Each atelier is individually vetted for craftsmanship, kavanah, and modesty standards.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {vendors.map((v, i) => (
          <Link key={v.id} to={`/vendor/${v.slug}`} className={`group block ${i%2===0 ? "" : "md:mt-24"}`}
                data-testid={`vendors-list-${v.slug}`}>
            <div className="aspect-[4/3] overflow-hidden bg-[#EAE5D9]">
              <img src={v.banner_image} alt={v.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"/>
            </div>
            <div className="mt-6 flex justify-between items-start">
              <div>
                <p className="label-uppercase text-[#D4A373]">{v.hechsher}</p>
                <h3 className="font-serif text-3xl md:text-4xl tracking-tighter mt-2">{v.name}</h3>
                <p className="text-[#4A4A4A] mt-2 max-w-md">{v.tagline}</p>
              </div>
              <ArrowUpRight className="w-6 h-6 mt-2 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"/>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
